import { render } from "./VariablesPanel.vue?vue&type=template&id=ded8a186&scoped=true"
import script from "./VariablesPanel.vue?vue&type=script&lang=js"
export * from "./VariablesPanel.vue?vue&type=script&lang=js"

import "./VariablesPanel.vue?vue&type=style&index=0&id=ded8a186&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded8a186"]])

export default __exports__